import React from "react";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { transform } from "framer-motion";
import { all } from "axios";
import { margin, padding } from "@mui/system";

const VARIANTS = {
  primary: {
    backgroundColor: "#D9B46B",
    color: "#000000 !important",
    border: "1px solid #D9B46B !important",
    borderRadius: "100px",
    "&:hover": {
      backgroundColor: "#D9B46B !important",
      borderColor: "#D9B46B !important",
      color: "#FFFFFF !important",
    },
  },
  secondary: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black !important",
    borderRadius: "100px",
    "&:hover": {
      border: "1px solid black !important",
      backgroundColor: "black",
      color: "#FFFFFF",
    },
  },
  slider: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "#D9B46B",
    border: "none",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
  },
  error: {
    backgroundColor: "transparent",
    color: "red !important",
    border: "1px solid red",
    borderRadius: "100px",
    "&:hover": {
      border: "1px solid red",
      backgroundColor: "red !important",
      color: "#FFFFFF !important",
    },
  },
};

const StyledBrandButton = styled(MuiButton)(({ brandvariant }) => ({
  ...(VARIANTS[brandvariant] || VARIANTS.primary),
  fontFamily: "Oswald, sans-serif",
  fontSize: "16px",
  fontWeight: 600,
  padding: brandvariant === "slider" ? "8px 15px" : "8px 16px",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    ...(VARIANTS[brandvariant] || VARIANTS.primary)["&:hover"],
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
  },
}));

const BrandButton = ({ variant = "primary", children, ...rest }) => {
  return (
    <StyledBrandButton
      variant={
        variant === "secondary" || variant === "error"
          ? "outlined"
          : "contained"
      }
      brandvariant={variant}
      disableElevation
      {...rest}
    >
      {children}
    </StyledBrandButton>
  );
};

export default BrandButton;
